import { Box, Skeleton } from "@mui/material";

const PlaceDetailsSkeleton = () => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        position: "relative",
      }}
    >
      {/* 1. PlaceCard Area */}
      <Box sx={{ px: "4%", mb: "2%" }}>
        {/* Title & Address */}
        <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={20} sx={{ mb: 2 }} />

        {/* Tags */}
        <Box
          sx={{ display: "flex", gap: "2%", mb: "4%", alignItems: "center" }}
        >
          <Skeleton
            variant="rounded"
            width={120}
            height={32}
            sx={{ borderRadius: "6px" }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1%",
              width: "50%",
            }}
          >
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width="40%" height={20} />
          </Box>
        </Box>

        {/* Media Title */}
        <Skeleton variant="text" width="30%" height={24} sx={{ mb: "1%" }} />

        {/* Media List */}
        <Box sx={{ display: "flex", gap: "2%", mb: "4%", overflowX: "hidden" }}>
          {[1, 2, 3].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                width: { xs: "19.42vw", sm: "25%" },
                height: { xs: "19.42vw", sm: "25%" },
                borderRadius: "12px",
                flexShrink: 0,
              }}
            />
          ))}
        </Box>
      </Box>

      {/* 2. Tabs */}
      <Box sx={{ borderColor: "divider", mb: "4%", px: "4%" }}>
        <Box sx={{ display: "flex", gap: "6%" }}>
          <Skeleton variant="text" width={60} height={40} />
          <Skeleton variant="text" width={80} height={40} />
        </Box>
      </Box>

      {/* 3. Content (Notes) */}
      <Box sx={{ px: "4%", flex: 1, overflow: "hidden" }}>
        {[1, 2, 3, 4].map((i) => (
          <Box key={i} sx={{ mb: 2 }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
          </Box>
        ))}
      </Box>

      {/* 4. Action Buttons (Fixed at bottom) */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: "#fff",
          p: "2%",
          borderTop: "1px solid #f0f0f0",
          display: "flex",
          gap: "4%",
        }}
      >
        <Skeleton
          variant="rounded"
          height={40}
          sx={{ borderRadius: "20px", flex: 1 }}
        />
        <Skeleton
          variant="rounded"
          height={40}
          sx={{ borderRadius: "20px", flex: 1 }}
        />
      </Box>
    </Box>
  );
};

export default PlaceDetailsSkeleton;
